var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polyline',{attrs:{"points":"22,7 13.5,15.5 8.5,10.5 2,17"}}),_c('polyline',{attrs:{"points":"16,7 22,7 22,13"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }